import { createMuiTheme } from 'material-ui/styles';
import teal from 'material-ui/colors/teal';
import red from 'material-ui/colors/red';

const theme = createMuiTheme({
  palette: {
    primary: {
      ...teal,
      A700: '#3cb482',
      main: teal.A700
    },
    error: {
      ...red,
      A400: '#db2828',
      main: red.A400
    }
  },
  // https://github.com/callemall/material-ui/tree/v1-beta/src 에서 직접 보고 찾는것이 편함
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: '12px !important',
        padding: '3px 8px !important'
      }
    }
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/materialUiTheme.js